<template>
	<div :class="classNames+ '_subwrap'">
		<div :class="classNames+ '_tips'">自动回复：默认支持所有课程</div>
		<div :class="classNames+ '_main'">
			<div :class="classNames+ '_content'">
				<useTable :searchForm="searchForm" :httprequest="httprequest" ref="useTable" :headerList="headerData" :showEmptyTable="false"></useTable>
			</div>
		</div>
		<!-- 话术卡片弹出 -->
		<replyDialog v-model="showReplyDialog" :replyFormInfo="replyFormInfo" @replyList="getReplyList"></replyDialog>
	</div>
</template>
<script>
	
import useTable from '@/components/useTable/useTable.vue'
import { mapActions } from 'vuex'
import replyDialog from './autoReplyDialog.vue'
export default {
	props: {
		tabIndex: {
		    type: Number,
		    default: 2
		}
	},
	data() {
		return {
			classNames: 'autoList',
			showReplyDialog: false,
			searchForm: [
				{
					defaultValue: '',
					label: '规则名称:',
				    Component: 'el-input',
					prop: 'name',
					span: 8,
				    componentProps: {
				        placeholder: '请输入规则名称'
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '查询'
				    },
				    on: {
				        click: this.getReplyList
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '+新建自动回复'
				    },
				    on: {
				        click: this.addReplyModal
				    }
				},
			],
			headerData: [
				{
					props: {
				        prop: 'name',
				        label: '规则名称',
				        width: 100
				    }
				},
				{
					props: {
				        prop: 'condition_type_desc',
				        label: '触达条件',
						width: 120
				    }
				},
				{
					props: {
				        prop: 'condition_value_desc',
				        label: '关键词/触发条件',
						width: 150
				    },
					render:(h, scope)=> {
						if(scope.row.condition_type == 1){
							return(
							    <div>
							        {
							        scope.row.keywords.map((item, index)=>{
										return(	<span key={item.id}>{item.key}、</span>)
							        })
							        }
							    </div>
							)
							
						} else {
							return (
								<div>
									{scope.row.condition_value_desc}
								</div>
							)
						}
					}
				},
				{
					props: {
				        prop: 'reply_type_desc',
				        label: '类型',
						width: 80
				    }
				},
				{
					props: {
                        prop: 'content',
                        label: '内容'
                    },
					render:(h, scope)=> {
						if(scope.row.reply_type == 2){
							return (
								<div>
								{scope.row.content} <span class={this.classNames+'_operation_title'} onClick={this.replyLinkFun.bind(this,scope.row)}>{scope.row.link_title}</span> 
								</div>
							)
						} else {
							return (
								<div>
									{scope.row.content}
								</div>
							)
						}
					}
				},
				{
					props: {
				        prop: 'people_count',
				        label: '触达人数',
				        width: 80
				    }
				},
				{
					props: {
				        prop: 'send_count',
				        label: '触发次数',
				        width: 80
				    }
				},
				{
					props: {
				        prop: 'created_time',
				        label: '创建时间',
				        width: 160
				    }
				},
                {
                    props: {
                        label: '操作',
                        width: 220
                    },
                    render:(h, scope)=> {
                        return (
							<div>
								<span class={this.classNames+'_operation_title'} onClick={this.replyEditModal.bind(this,scope.row)}>编辑</span>
								<span class={this.classNames+'_operation_title'} onClick={this.replyShowHideFun.bind(this,scope.row)}>{this.formatShowText(scope.row)}</span>
								<span class={this.classNames+'_operation_title'} onClick={this.replyDeleteFun.bind(this,scope.row)}>删除</span>
								{scope.row.sort == 0 ? <span class={this.classNames+'_operation_disable'} >置顶</span> : <span class={this.classNames+'_operation_title'} onClick={this.replyTopFun.bind(this,scope.row)}>置顶</span>}
								
							</div>
						)
                    }
                }
			],
			replyFormInfo:{},
		}
	},
	components: {
		useTable,
		replyDialog
	},
	created() {
	},
	methods: {
		...mapActions('dymessage', ['autoReply','autoReplyTop','replyDel','replyShowHide']),
		getReplyList(status = true) {
			if(status){
				this.$refs.useTable.getRequestRes('firstPage')
			} else {
				this.$refs.useTable.getRequestRes()
			}
		},
		addReplyModal() {
			this.showReplyDialog = true
			this.replyFormInfo = Object.assign({}, {
			   id: '',
			   name: '',
			   condition_type: 1,
			   keywords:  [{key_rule: 1,key:''}],
			   condition_value: 1,
			   reply_type: 1,
			   content: '',
			   card_id:  0
			})
		},
		async replyTopFun(data){
			await this.autoReplyTop({id:data.id})
			await this.getReplyList()
		},
		replyLinkFun(data){
			window.open(data.link_url)
		},
		replyEditModal(data){
			const replyFormInfo = Object.assign({},data)
			if(replyFormInfo.keywords.length == 0) {
				replyFormInfo.keywords.push({key_rule: 1,key:''})
			}
			this.replyFormInfo = replyFormInfo
			this.showReplyDialog = true
		},
		async replyDeleteFun(data){
			const reply_type = this.tabIndex
			this.$confirm(`确定要删除吗?`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			    }).then(async () => {
			        await this.replyDel({id:data.id,reply_type: reply_type})
			        await this.getReplyList()
			        this.$message({
			            type: 'success',
			            message:'删除成功',
			            duration: 3000
			        })
			    })
				
			
		},
		async replyShowHideFun(data){
			console.log('data',data)
			let is_show = ''
			if(data.is_show == 1) {
				is_show = 2
			} else if(data.is_show == 2) {
				is_show = 1
			} else {
				is_show == 2
			}
			await this.replyShowHide({id:data.id, is_show: is_show,reply_type: this.tabIndex})
			await this.getReplyList(false)
		},
		formatShowText(data){
			if(data.is_show == 1){
				return '隐藏'
			} else if(data.is_show == 2){
				return '显示'
			} else {
				return ''
			}
		},
		async httprequest(params) {
			params.limit = params.pageSize
			let res = await this.autoReply(params)
			return {total: res.count,data: res.list}
		}
	}
}
</script>
<style lang="less" scoped>
	 @classNames: autoList;
	 .@{classNames}_headtool{
		 margin-bottom: 20px;
	 }
	 .@{classNames}_main{
		// display: flex;
	 }
	 .@{classNames}_content{
		 display: flex;
		 flex-direction: column;
		 flex: 1;
	 }
</style>
<style lang="less">
	@classNames: autoList;
	.@{classNames}_operation_title,.@{classNames}_operation_disable {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
	}
	.@{classNames}_operation_disable{
		color: #bababa;
	}
	.@{classNames}_tips{
		color: #bababa;
		margin-bottom: 20px;
		font-size: 14px;
	}
</style>
